import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialState = [
  {
    id: null,
    item: null,
    qty: 0,
    rate: 0,
    type: "",
    total: 0,
    note: "",
    Dis:0,
    deliveryDate: dayjs().format(),
  },
];

const billTableSlice = createSlice({
  name: "billTable",
  initialState,
  reducers: {
    // Update a specific row in the table
    UPDATE_TABLE_ROW(state, action) {
      const { index, qty, rate, ...fields } = action.payload;
      if (state[index]) {
        // Update the row with new fields
        Object.assign(state[index], fields);

        // Update `qty` and `rate` if provided
        if (qty !== undefined) state[index].qty = qty;
        if (rate !== undefined) state[index].rate = rate;

        // Recalculate the `total` field
        state[index].total = (state[index].qty * state[index].rate)-(state[index].Dis|| 0);
      }
    },

    // Add a new row to the table
    ADD_BILL_TABLE_ROW(state, action) {
      state.push({
        id: null,
        item: null,
        qty: 0,
        rate: 0,
        type: "",
        total: 0,
        note: "",
      });
    },

    // Remove a row from the table
    REMOVE_BILL_TABLE_ROW(state, action) {
      const { index } = action.payload;
      if (state[index]) {
        state.splice(index, 1);
      }
    },

    // Reset the table to the initial state
    RESET_BILL_TABLE() {
      return initialState;
    },

    // Replace the entire table with new data
    REPLACE_BILL_TABLE(state, action) {
  
      return [...action.payload]; // Ensuring a new array reference
    },
    
  },
});

export const {
  UPDATE_TABLE_ROW,
  ADD_BILL_TABLE_ROW,
  REMOVE_BILL_TABLE_ROW,
  RESET_BILL_TABLE,
  REPLACE_BILL_TABLE,
} = billTableSlice.actions;

export default billTableSlice.reducer;
